export default "__VITE_ASSET__4b3e9081__"